import { useMemo } from 'react'
import { useTranslations } from '@npco/utils-translations'
import {
  InfoBox,
  INFOBOX_VARIANT,
  SkeletonBasic,
} from '@npco/zeller-design-system'
import { useFormikContext } from 'formik'

import { translations } from '../ItemsSettingsForm.i18n'
import { ItemsSettingsFormFields } from '../ItemsSettingsForm.types'

type GstDisplayInfoboxProps = {
  isLoading: boolean
  itemCountForGstSetting: number
}

export const GstDisplayInfobox = ({
  isLoading,
  itemCountForGstSetting,
}: GstDisplayInfoboxProps) => {
  const t = useTranslations(translations)
  const { values } = useFormikContext<ItemsSettingsFormFields>()
  const infoMessage = useMemo(() => {
    const taxStatus = values.isTaxInclusive
      ? t('taxInclusive')
      : t('taxExclusive')

    if (!itemCountForGstSetting) {
      return t('taxInfoMessageNoItems', { taxStatus })
    }

    return t('taxInfoMessage', {
      itemsCount: itemCountForGstSetting,
      taxStatus,
    })
  }, [itemCountForGstSetting, t, values.isTaxInclusive])

  if (isLoading) {
    return <SkeletonBasic height="50px" borderRadius="8px" />
  }

  return (
    <InfoBox
      variant={
        itemCountForGstSetting
          ? INFOBOX_VARIANT.NEGATIVE
          : INFOBOX_VARIANT.NEUTRAL
      }
    >
      <InfoBox.Message>{infoMessage}</InfoBox.Message>
    </InfoBox>
  )
}
